export function getFormattedDate(daysToAdd, serverDate) {
  if (typeof daysToAdd !== "number" || !serverDate) {
    return null;
  }

  const date = new Date(serverDate.year, serverDate.month - 1, serverDate.day + daysToAdd);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
}
